export const summaryRows: string[] = [
  "Volume 1 — Fondamenti di Meteorologia e Scienze dell'Atmosfera",
  "Volume 2 — Energia, Temperatura e Termodinamica dell'Atmosfera",
  'Volume 3 — Nubi, Precipitazioni e Umidità Atmosferica',
  "Volume 4 — Circolazione Atmosferica, Masse d'Aria e Sistemi Meteorologici",
  'Volume 5 — Maltempo Severo ed Eventi Atmosferici Estremi',
  'Volume 6 — Osservazione Meteorologica, Strumenti e Dati Meteo',
  "Bonus 1 — 150 Attività in Classe di Meteorologia e Scienze dell'Atmosfera",
  'Bonus 2 — Kit Completo di Valutazione in Meteorologia',
  'Bonus 3 — 100 Casi di Studio su Meteo e Atmosfera',
  'Bonus 4 — 100 Esperimenti, Indagini e Sfide di Meteorologia',
  'Bonus 5 — Biblioteca di Risorse per la Programmazione delle Lezioni di Meteorologia',
  'Garanzia di soddisfazione di 7 giorni',
  'Accesso immediato',
];
